import React from 'react';
import { article, introBlocks, introImage } from '../data/article';
import { ArticleFigure } from './ArticleFigure';
import { Prose } from './Prose';
export function ArticleHeader() {
  return <header className="px-5 pb-4 pt-10 sm:px-8 md:pt-16" data-id="element-11" data-mp="i3vlidhuy3q7">
      <div className="mx-auto max-w-[42rem]" data-id="element-12" data-mp="i5gi08nqfwqp">
        <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-600" data-id="element-13" data-mp="n1nd16elbntv">
          {article.eyebrow}
        </p>
        <h1 className="mt-4 text-[32px] font-extrabold leading-[1.12] tracking-[-0.025em] text-ink sm:text-[42px] md:text-[48px]" data-id="element-14" data-mp="1asjd0qt79pc7">
          {article.headline}
        </h1>
        <p className="mt-5 max-w-[34rem] text-[18px] leading-relaxed text-neutral-600 sm:text-[20px]" data-id="element-15" data-mp="112zr1ca6xfd4">
          {article.dek}
        </p>
      </div>

      <ArticleFigure image={introImage} className="mx-auto mt-8 max-w-3xl" data-id="element-16" data-mp="15z81icdg0kdy" />

      <div className="mx-auto mt-10 max-w-[42rem]" data-id="element-17" data-mp="1tpaucup6ludm">
        <Prose blocks={introBlocks} data-id="element-18" data-mp="1yi3wrbx6gqmj" />
      </div>
    </header>;
}